module.exports = __webpack_public_path__ + "img/share_wechart.151aa21f.png";